import React from 'react';
import ShopBase from './ShopBase';
import sreeBg from '../assets/sree_selection.jpg'; // or gradient image later

const sreeTheme = {
  background: sreeBg,

  pointsColor: '#00ffd5',

  rewardsBg: 'rgba(190, 255, 240, 0.85)',
  rewardsBorder: '#00c9a7',
  rewardsTitle: '#009688',

  choresBg: 'rgba(220, 200, 255, 0.85)',
  choresBorder: '#7c4dff',
  choresTitle: '#5e35b1',
};

function SreeShop() {
  return <ShopBase user="sree" other="rija" theme={sreeTheme} />;
}

export default SreeShop;
